module.exports = __webpack_public_path__ + "static/media/confer-scarlatti.f56282cc.mp4";